import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  .img-size {
    width: 75%;
    height: 75%;
    visibility: hidden;
  }
  .flip-card {
    top: 0;
    left: 0;
    position: absolute;
    width: 75%;
    height: 100%;
    transform-style: preserve-3d;
    transition: all 0.5s ease;
    -webkit-animation: flipY 8s infinite ease-in-out;
    animation: flipY 8s infinite ease-in-out;
    img {
      width: 100%;
      height: 100%;
    }
    .card-front {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
    }
    .card-back {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      transform: rotateY(180deg);
    }
  }
`;
